import { useEffect, useState } from 'react'
import DataTable from '../components/DataTable';
import { KTSVG } from '../../_metronic/helpers'
import 'react-loading-skeleton/dist/skeleton.css';
import { Link } from 'react-router-dom';
import { getRequestOptions } from '../helpers/Fetchwrapper';
import Select from 'react-select';
import SalesInvoiceAdjustment from '../components/SalesInvoiceAdjustment';

function SalesInvoice() {


    const hasPermission = 1; //parseInt(GetPagePermission("/setup-company-list"));

    const [selectProjectOptions, setSelectProjectOptions] = useState([])
    const [project, setProject] = useState({ label: 'Select Project', value: '' });
    const [newData, setNewData] = useState({});
    const [id, setId] = useState(0);

    const [showSalesInvoiceAdjustment, setShowSalesInvoiceAdjustment] = useState(false);

    const makeAdjustment = (idSalesInvoice: number) => {
        setId(idSalesInvoice)
        setShowSalesInvoiceAdjustment(true);
    }

    const handleSalesInvoiceAdjustmentClose = (isReload: boolean) => {
        setShowSalesInvoiceAdjustment(false);
        if (isReload) {
            setNewData({ id: Date.now() });
        }
    }

    const handleProjectChange = (project: any) => {
        setProject(project);
    }

    const getProjectList = async () => {
        const url = process.env.REACT_APP_API_URL + 'projects';
        const response = await fetch(url, getRequestOptions());
        const data = await response.json();
        data.data.map((element: any) => {
            element.value = element.id_projects;
            element.label = element.project_name;
            return element;
        })

        if (data.data.length === 1) {
            setSelectProjectOptions(data.data)
        } else {
            var allProjectsOpt = [{ id: '', name: '', label: 'All Project', value: '' }]
            let allProjects = data.data.concat(allProjectsOpt);
            setSelectProjectOptions(allProjects);
        }

    }

    const numberFormat = (value: any) => {

        value = parseFloat(value)
        if (typeof (value) !== 'number') {
            return value;
        }
        return parseFloat(value.toString()).toLocaleString('en-US', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    useEffect(() => {
        getProjectList();
    }, [])

    useEffect(() => {
        if (selectProjectOptions.length === 1) {
            setProject({ label: selectProjectOptions[0]['label'], value: selectProjectOptions[0]['value'] })
        }
    }, [selectProjectOptions])

    useEffect(() => {
        setAdditionalPostData({ idProjects: project.value })
    }, [project])

    const [additionalPostData, setAdditionalPostData] = useState({ idProjects: '' });

    const columns = [
        { value: 'id', title: 'ID', style: { textAlign: 'center' } },
        { value: 'invoiceId', title: 'Invoice ID', style: { textAlign: 'center' } },
        { value: 'referenceNo', title: 'Reference No.', style: { textAlign: 'center' } },
        { value: 'idSalesOrders', title: 'Sales Order ID', style: { textAlign: 'center' } },
        { value: 'projectName', title: 'Project', style: { textAlign: 'center' } },
        { value: 'companyName', title: 'Client', style: { textAlign: 'center' } },
        { value: 'invoiceDate', title: 'Invoice Date', style: { textAlign: 'center' } },
        { value: 'creditDays', title: 'Credit Days', style: { textAlign: 'center' } },
        {
            value: 'overDueDate', title: 'Over Due Date', style: { textAlign: 'center' },
        },
        {
            value: 'invoiceAmount', title: 'Invoice Amount', style: { textAlign: 'center', whiteSpace: 'nowrap' }, hasHtmlComponent: true, htmlComponent: ((row: any) => {
                const currentDate = new Date();
                const overDueDate = new Date(row.overDueDate);
                const isDanger = row.dueAmount > 0 && overDueDate < currentDate;
                
                return (
                    <span 
                        className={isDanger ? 'text-danger fw-bold' : ''} 
                        title={`Due Amount: ${numberFormat(row.dueAmount)}`}
                        style={{ cursor: 'help' }}
                    >
                        {numberFormat(row.invoiceAmount)}
                    </span>
                )
            }),
        },
        {
            value: 'advanceAdjustment', title: 'Adjustment', style: { textAlign: 'center', whiteSpace: 'nowrap' }, hasHtmlComponent: true, htmlComponent: ((row: any) => {
                return numberFormat(row.advanceAdjustment)
            }),
        },
        { value: 'shipments', title: 'Shipments', style: { textAlign: 'center' } },
        { value: 'createdBy', title: 'Created By', style: { textAlign: 'left' } },
        {
            value: 'action', title: 'Action', style: { textAlign: 'left', whiteSpace: 'nowrap' }, hasActionsComponent: true, actionsComponent: ((row: any) => {
                return (
                    <>
                        <button className="btn btn-light-primary btn-sm" onClick={() => makeAdjustment(row.id)}>
                            <KTSVG
                                path='/media/svg/icons/Design/Crop.svg'
                                className='svg-icon-5 svg-icon'
                            />		Adjustment
                        </button>
                        <Link className="btn btn-light-primary btn-sm" to={`sales-invoice/${row.id}`}>
                            <KTSVG
                                path='/media/svg/icons/Layout/Layout-grid.svg'
                                className='svg-icon-5 svg-icon'
                            />		Details
                        </Link>
                        <a className="btn btn-light-primary btn-sm" target="_blank" rel="noopener noreferrer" href={`${process.env.REACT_APP_BACKEND}invoiceDownload/${row.id}`}>
                            <KTSVG
                                path='/media/svg/icons/Files/Downloads-folder.svg'
                                className='svg-icon-5 svg-icon'
                            />		Download
                        </a>

                    </>
                )
            })
        }
    ]

    const filters = {
        id: {
            filterType: 'like',
            filterValue: '',
        },
        invoiceId: {
            filterType: 'like',
            filterValue: '',
        },
        referenceNo: {
            filterType: 'like',
            filterValue: '',
        },
        idSalesOrders: {
            filterType: 'like',
            filterValue: '',
        },
        projectName: {
            filterType: 'like',
            filterValue: '',
        },
        companyName: {
            filterType: 'like',
            filterValue: '',
        },
        invoiceDate: {
            filterType: 'like',
            filterValue: '',
        },
        overDueDate: {
            filterType: 'like',
            filterValue: '',
        },
        creditDays: {
            filterType: 'like',
            filterValue: '',
        },
        invoiceAmount: {
            filterType: 'like',
            filterValue: '',
        },
        advanceAdjustment: {
            filterType: 'like',
            filterValue: '',
        },
        // receivedAmount: {
        //     filterType: 'like',
        //     filterValue: '',
        // },
        // dueAmount: {
        //     filterType: 'like',
        //     filterValue: '',
        // },
        shipments: {
            filterType: 'like',
            filterValue: '',
        },
        createdBy: {
            filterType: 'like',
            filterValue: '',
        },
    }

    const url = process.env.REACT_APP_API_URL + 'sales-invoice/dt'

    return (
        <>
            {hasPermission === 1 &&
                <>
                    <div className='card card-custom'>
                        <div className='card-header'>
                            <div className="card-title">
                                <KTSVG path='/media/svg/icons/Text/Bullet-list.svg' className='svg-icon-1 svg-icon-primary' />
                                <span className='text fw-bolder' style={{ marginLeft: '10px' }}>
                                    Sales Invoices
                                </span>
                            </div>
                            <div className="card-toolbar">
                                <div className='d-flex justify-content-end'>
                                    <Select
                                        // defaultValue={selectProjectOptions}
                                        onChange={handleProjectChange}
                                        options={selectProjectOptions}
                                        placeholder={project.label}
                                    />
                                    &nbsp;
                                    <Link to={`/sales-invoice-create`} className="btn btn-sm btn-primary"><i className="fa fa-plus"></i>Create New Sales Invoice</Link>
                                </div>
                            </div>
                        </div>

                        <div className='card-body'>
                            <DataTable url={url} columns={columns} filters={filters} additionalPostData={additionalPostData} newData={newData} />
                        </div>
                    </div >

                    <SalesInvoiceAdjustment show={showSalesInvoiceAdjustment} handleClose={handleSalesInvoiceAdjustmentClose} id={id} />

                </>
            }


            {/* {hasPermission === 0 &&
                <Error />
            }
            {hasPermission === 0 &&
                <div className='card card-custom' style={{ padding: "15px" }} >
                    <SkeletonTheme>
                        <p>
                            <Skeleton
                                containerClassName="avatar-skeleton"
                                count={40} ></Skeleton>
                        </p>
                    </SkeletonTheme>
                </div>
            } */}

        </>
    )
}

export default SalesInvoice
